import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import axios from "axios";
import "../admin.css";
import { NavLink } from "react-router-dom";
import $ from "jquery";

const EditRole = (props) => {
  const [params] = useState(props.match.params);
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [message, setMessage] = useState({
    type: null,
    text: "",
  });

  const [role, setRole] = useState({
    name: "",
    rank: "",
  });

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setRole((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const saveRole = async (e) => {
    e.preventDefault();
    let error = false;
    if (role.name === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter role name.",
        };
      });
      return;
    }
    if (role.rank === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter role rank.",
        };
      });
      return;
    }

    if (!error) {
      await axios
        .put(
          localStorage.getItem("basurl") + "/roles",
          {
            name: role.name,
            rank: role.rank,
            id: role.id,
          },
          { headers: { "mojo-access-tokens": user.token } }
        )
        .then((response) => {
          setMessage(() => {
            return {
              type: "success",
              message: response.data.message,
            };
          });

          setRole({ name: "", rank: "" });
        })
        .catch((error) => {
          setMessage(() => {
            return {
              type: "danger",
              message: error.response.data.message,
            };
          });
        });
    }
  };

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  const getRole = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/roles/" + params.id, {
          headers: {
            "mojo-access-tokens": user.token,
          },
        })
        .then((response) => {
          response.data.forEach((value) => {
            let val = value;
            setRole((prevState) => {
              return {
                ...prevState,
                ...val,
              };
            });
          });
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getRole();
  }, []);

  return (
    <>
      <div className="card shadow-base form-layout form-layout-4">
        <h6 className="tx-gray-800 tx-uppercase tx-bold tx-14 mg-b-10">
          Update a Role
        </h6>
        <p className="mg-b-30 tx-gray-600">
          Fields masked with <span className="tx-danger">*</span> are required.
        </p>
        {getMessage()}

        <div className="row mg-t-20">
          <label className="col-sm-4 form-control-label">
            Name: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-8 mg-t-10 mg-sm-t-0">
            <input
              id="name"
              name="name"
              type="text"
              className="form-control"
              placeholder="Enter role name"
              autoComplete="off"
              onFocus={resetMessage}
              onChange={handleChange}
              value={role.name}
            />
          </div>
        </div>
        <div className="row mg-t-20">
          <label className="col-sm-4 form-control-label">
            Rank: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-8 mg-t-10 mg-sm-t-0">
            <input
              id="rank"
              name="rank"
              className="form-control"
              placeholder="Enter role rank"
              autoComplete="off"
              onFocus={resetMessage}
              onChange={handleChange}
              value={role.rank}
            />
          </div>
        </div>
        <div className="form-layout-footer mg-t-30 tx-right">
          <NavLink to="/admin/roles"> My Roles </NavLink> &nbsp; &nbsp; &nbsp;
          <button
            onClick={saveRole}
            className="btn btn-info"
            style={{ cursor: "pointer" }}
          >
            Save
          </button>
          &nbsp;&nbsp;
        </div>
      </div>
    </>
  );
};

export default EditRole;
